import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  PROVIDER_FORM_ADDRESS_FIELD_MAX_LENGTH,
  PROVIDER_FORM_FIELD_NAME_ADDRESS,
} from '../../ProviderForm.constants'

function AddressField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Provider.AddressFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={PROVIDER_FORM_ADDRESS_FIELD_MAX_LENGTH}
      name={PROVIDER_FORM_FIELD_NAME_ADDRESS}
      placeholder={t('Provider.AddressFieldPlaceholderKey')}
    />
  )
}

export default AddressField
